module.exports = __webpack_public_path__ + "static/media/Round_stamp.ecd3591f.png";